<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Prescrições Padronizadas</h3>
    <mat-slide-toggle [disabled]="this.readOnly" class="medicated_solution" [checked]="isMedicatedSolution" (change)="changeToMedicatedSolution($event)">
      Montar solução
    </mat-slide-toggle>
  </div>

  <div class="mat-dialog-content">
    @if (!isMedicatedSolution) {
      <app-medicine-form
        [blockAllergicPrescription]="this.data.blockAllergicPrescription"
        [readOnly]="this.readOnly"
        [prescriptionMedicineStruct]="$safeNavigationMigration(this.prescription?.prescriptionMedicineStruct)"
        [listAllergy]="this.listAllergy"
        [selectedMedicineList]="this.selectedMedicineList"
        [medicineList]="this.medicineList"
        [listSubFrequency]="this.listSubFrequency"
        [frequencyList]="this.frequencyList"
        [presentationList]="this.presentationList"
        [treatmentList]="this.treatmentList"
        [dilutionList]="this.dilutionList"
        [measurementUnitList]="this.measurementUnitList"
        [usageList]="this.usageList"
        [administrationTypeList]="this.administrationTypeList"
        [lookupMedicalCareResponse]="this.data.lookupMedicalCareResponse"
        [listMedicine]="this.medicineList"
        [medicConfig]="this.medicConfig"
        [dilutionUnitList]="this.dilutionUnitList"
        [pharmacyConfig]="$safeNavigationMigration(this.data?.pharmacyConfig)"
        [listDoseToAdministered]="$safeNavigationMigration(this.data?.listDoseToAdministered)"
        [listLookupAdministrationLocation]="this.data.listMedicine.listLookupAdministrationLocation"
        [listRelationMedicinePresentationTypeAndDoseToAdministered]="this.listRelationMedicinePresentationTypeAndDoseToAdministered"
        (save)="submit($event)"
        (cancel)="close()"
        [hasNewStandardPrescription]="this.data.hasNewStandardPrescription">
      </app-medicine-form>
    }
    @if (isMedicatedSolution) {
      <app-medicated-solution-form
        [blockAllergicPrescription]="this.data.blockAllergicPrescription"
        [readOnly]="this.readOnly"
        [prescriptionSolutionStruct]="$safeNavigationMigration(this.prescription?.prescriptionSolutionStruct)"
        [listAllergy]="this.listAllergy"
        [selectedMedicineList]="this.selectedMedicineList"
        [medicineList]="this.medicineList"
        [listSubFrequency]="this.listSubFrequency"
        [frequencyList]="this.frequencyList"
        [presentationList]="this.presentationList"
        [treatmentList]="this.treatmentList"
        [dilutionList]="this.dilutionList"
        [measurementUnitList]="this.measurementUnitList"
        [listLookupAdministrationLocation]="this.data.listMedicine.listLookupAdministrationLocation"
        [usageList]="this.usageList"
        [pharmacyConfig]="$safeNavigationMigration(this.data?.pharmacyConfig)"
        [administrationTypeList]="this.administrationTypeList"
        [lookupMedicalCareResponse]="this.data.lookupMedicalCareResponse"
        [listMedicine]="this.medicineList"
        [dilutionUnitList]="this.dilutionUnitList"
        [medicConfig]="this.medicConfig"
        [listDoseToAdministered]="$safeNavigationMigration(this.data?.listDoseToAdministered)"
        [listRelationMedicinePresentationTypeAndDoseToAdministered]="this.listRelationMedicinePresentationTypeAndDoseToAdministered"
        (save)="submit($event)"
        (cancel)="close()"
        [hasNewStandardPrescription]="this.data.hasNewStandardPrescription">
      </app-medicated-solution-form>
    }
  </div>
</div>